import { useState } from "react";
import { MapPinned } from "lucide-react";
import { api, errText } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { Switch } from "./ui/switch";
import { toast } from "sonner";

export function SightingEmailPref({ user }) {
  const { t } = useLanguage();
  const [on, setOn] = useState(user?.sighting_emails !== false);
  const [saving, setSaving] = useState(false);
  const toggle = async (v) => {
    setOn(v); setSaving(true);
    try { await api.put("/auth/me/preferences", { sighting_emails: v }); toast.success(v ? t("sa_on") : t("sa_off")); }
    catch (e) { setOn(!v); toast.error(errText(e)); }
    finally { setSaving(false); }
  };
  return (
    <div className="max-w-xl bg-white rounded-2xl border border-slate-200/80 p-6 flex items-start gap-4" data-testid="sighting-email-pref">
      <span className="h-10 w-10 rounded-xl bg-red-50 flex items-center justify-center shrink-0"><MapPinned size={20} className="text-red-600" /></span>
      <div className="flex-1">
        <p className="font-display font-bold text-[#12234A]">{t("sa_title")}</p>
        <p className="text-sm text-slate-500 mt-0.5">{t("sa_desc")}</p>
      </div>
      <Switch checked={on} disabled={saving} onCheckedChange={toggle} data-testid="sighting-email-toggle" />
    </div>
  );
}
